export default {
	qita: '其他',
	chengjirenyixuanze: '乘机人已选择，不可重复选择',
	dingdanzhuangtai: '订单状态',
	daifukuan: '待付款',
	daichupiao: '出票中',
	chupiaowancheng: '出票完成',
	quxiao: '取消',
	yinhangka: '银行卡',
	dianziqianbao: '电子钱包',
	yiwancheng: '已完成',
	weiwancheng: '未完成',
	zhifuzhong: '支付中',
	quxiaozhong: '取消中',
	zhifuweiwancheng: '支付未完成',
	jixuzhifu: '继续支付',
	chongxingoumai: '重新购买',
	ninhaiweiwanchengzhifu: '您还未完成支付，是否继续支付？',
	chongxinxuanzezhifufangshi: '重新选择支付方式',
	quebaoziliao: '请确保所有资料正确',
	lianluorenziliao: '联络人资料',
	dianhuahaoma: '电话号码',
	fujiafuwu: '附加服务',
	feixingchangkehaoma: '飞行常客号码',
	dianziyouhuiquan: '电子优惠券',
	meiyoudianziyouhui: '没有申请电子优惠券',
	wodedaima: '我有代码',
	jiayiri: '日',
	jiaerri: '日',
	xianzaifukuan: '现在付款',
	zhifuwancheng: '支付完成',
	yudaowenti: '遇到问题',
	qingninzaixindakaideyemian: '请您在新打开的页面进行支付！',
	zhifuwanchengqianqingbuyao: '支付完成前请不要关闭此窗口',
	cuowuyuanyin: '错误原因',
	zhifucuowu: '支付错误',
	bizhongbuzhichi: '不支持该货币',
	jinechaochuxianzhi: '金额超出限制',
	querenzhifu: '确认支付',
	xiugai: '修改',
	xiangqing: '详情',
	chengke: '乘客',
	daililianluoziliao: '代理联络资料',
	banlidengji: '办理登机',
	chakanguanli: '查看/管理',
	chufa: '出发',
	riqishijian: '日期/时间',
	yudingcankaobianhao: '预订参考编号',
	chengshijichang: '城市/机场',
	dao: '到',
	daoda: '到达',
	daodashijian: '到达时间',
	xingcheng: '行程',
	lieyin: '列印',
	shuikuanfapiao: '税款发票',
	genggaihangbanyaoqiu: '更改航班要求',
	lvxingshijian: '旅行时间',
	xinglie: '行李额',
	nian: '年',
	yue: '月',
	geshibuzhengque: '格式错误',
	lianxirenxingming: '联系人姓名',
	tuipiao: '退票',
	gaiqian: '改签',
	querenyaotuipiaoma: '确认要退票吗？',
	querenyaogaiqianma: '确认要改签吗？',
	pingtaifuwufei: '平台服务费',
	xuzhifu: '需支付',
	jishufuwufei: '技术服务费',
	canshucuowu: '参数错误',
	chupiaoshibaichongxinyuding: '出票失败，已退款成功，请重新预定。',
	chupiaoshibaibufentuikuanchenggong: '出票失败，已部分退款成功，如有疑问请联系客服。',
	chupiaoshibaituikuanshibai: '出票失败，退款失败，请联系客服处理。',
	dingdanzhuangtaiyichang: '订单状态异常',
	shouxufei: '手续费',
	xinglixinxi: '行李信息',
	xingli: '行李',
	dingdanxinxi: '订单信息',
	dingdantijiaochenggong: '订单提交成功',
	qingzhifu: '请在30分钟内付款，否则订单将被取消。',
	kezailiebiaochakan: '您可以在订单列表中查看该订单',
	chakandingdan: '查看订单',
	ri: '日',
	yiyue: '一月',
	eryue: '二月',
	sanyue: '三月',
	siyue: '四月',
	wuyue: '五月',
	liuyue: '六月',
	qiyue: '七月',
	bayue: '八月',
	jiuyue: '九月',
	shiyue: '十月',
	shiyiyue: '十一月',
	shieryue: '十二月',
	xuanzefukuanfangshi: '选择付款方式',
	qingyu: '请于',
	neiwanchengzhifu: '前完成支付',
	kaxinxi: '卡信息',
	xinyongkahao: '卡号',
	xinyongkayouxiaoqi: '信用卡有效期',
	chikarenxingshi: '持卡人姓氏',
	chikarenmingzi: '持卡人名字',
	youxiang: '邮箱',
	dianhua: '电话',
	shengfendiqu: '省份/地区',
	chengshi: '城市',
	youbian: '邮编',
	jiedaodizhi: '街道地址',
	zhangdanxinxi: '账单信息',
	dingdanbianhao: '订单编号:',
	dingdanbizhong: '订单币种:',
	dingdanjine: '订单金额:',
	guojia: '国家',
	zhuan: '转',
	ci: '次',
	fen: '分',
	miao: '秒',
};

